import { useEffect } from "react";

const SITE_URL = "https://zhinengce.cn";

type SeoProps = {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  type?: string;
  image?: string;
  schema?: object | object[];
};

function removeOld() {
  document.querySelectorAll("[data-readdy-seo]").forEach((el) => el.remove());
}

function ensureTag(tagName: string, attrs: Record<string, string>) {
  const el = document.createElement(tagName);
  el.setAttribute("data-readdy-seo", "1");
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  document.head.appendChild(el);
}

export default function Seo({
  title,
  description,
  keywords,
  path,
  type = "website",
  image,
  schema,
}: SeoProps) {
  const schemaKey = schema ? JSON.stringify(schema) : "";
  useEffect(() => {
    removeOld();
    const canonical = SITE_URL + path;
    document.title = title;

    const metaDefs: Record<string, [string, string]> = {
      description: ["name", "description"],
    };
    if (keywords) metaDefs.keywords = ["name", "keywords"];

    ensureTag("meta", { name: "robots", content: "index, follow" });
    Object.entries(metaDefs).forEach(([content, [k, n]]) =>
      ensureTag("meta", { [k]: n, content }),
    );
    ensureTag("link", { rel: "canonical", href: canonical });
    ensureTag("meta", { property: "og:locale", content: "zh_CN" });
    ensureTag("meta", { property: "og:site_name", content: "吃瓜路线" });
    ensureTag("meta", { property: "og:title", content: title });
    ensureTag("meta", { property: "og:description", content: description });
    ensureTag("meta", { property: "og:type", content: type });
    ensureTag("meta", { property: "og:url", content: canonical });
    if (image) ensureTag("meta", { property: "og:image", content: image });
    ensureTag("meta", { name: "twitter:card", content: "summary_large_image" });
    ensureTag("meta", { name: "twitter:title", content: title });
    ensureTag("meta", { name: "twitter:description", content: description });
    if (image) ensureTag("meta", { name: "twitter:image", content: image });

    if (schema && schemaKey) {
      const existing = document.getElementById("readdy-jsonld");
      if (existing) existing.remove();
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "readdy-jsonld";
      script.setAttribute("data-readdy-seo", "1");
      script.textContent = schemaKey;
      document.head.appendChild(script);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, keywords, path, type, image, schemaKey]);

  return null;
}

export { SITE_URL };